import type { ReactNode } from 'react';
import CurvedCorner from '@/components/ui/CurvedCorner';
import { getConditionalBackgroundStyle } from '@/pages/public/AdminLivePage';
import { useAppSelector } from '@/app/hooks';
import type { RootState } from '@/app/store';

interface IconWithConnectorProps {
  children: ReactNode;
  isActive: boolean;
  position: 'first' | 'middle' | 'last';
}

export default function IconWithConnector({
  children,
  isActive,
  position,
}: IconWithConnectorProps) {
  const { currentWorkspace } = useAppSelector((state: RootState) => state.workspace);
  const getConnectorClasses = () => {
    if (!isActive) return null;

    switch (position) {
      case 'first':
        return (
          <div
            className="absolute -bottom-4 left-0 w-full h-4 z-10"
            style={getConditionalBackgroundStyle({
              theme: currentWorkspace?.visualIdentity?.theme || 'LIGHT',
              defaultIdentity: currentWorkspace?.visualIdentity?.defaultIdentity,
              defaultIdentityColor:
                currentWorkspace?.visualIdentity?.secondaryBackgroundColor || '#C0D3FF',
              isActive: isActive,
            })}
          >
            {/* Cercle à droite seulement */}
            <div className="absolute bottom-0 -right-6 size-6">
              <CurvedCorner
                corner="bottom-left"
                shadowColor={
                  getConditionalBackgroundStyle({
                    theme: currentWorkspace?.visualIdentity?.theme || 'LIGHT',
                    defaultIdentity: currentWorkspace?.visualIdentity?.defaultIdentity,
                    defaultIdentityColor:
                      currentWorkspace?.visualIdentity?.secondaryBackgroundColor || '#C0D3FF',
                    isActive: isActive,
                  }).backgroundColor
                }
              />
            </div>
          </div>
        );
      case 'middle':
        return (
          <div
            className="absolute -bottom-4 left-0 w-full h-4 z-10"
            style={getConditionalBackgroundStyle({
              theme: currentWorkspace?.visualIdentity?.theme || 'LIGHT',
              defaultIdentity: currentWorkspace?.visualIdentity?.defaultIdentity,
              defaultIdentityColor:
                currentWorkspace?.visualIdentity?.secondaryBackgroundColor || '#C0D3FF',
              isActive: isActive,
            })}
          >
            {/* Cercles des deux côtés */}
            <div className="absolute bottom-0 -left-6 size-6 ">
              <CurvedCorner
                corner="bottom-right"
                shadowColor={
                  getConditionalBackgroundStyle({
                    theme: currentWorkspace?.visualIdentity?.theme || 'LIGHT',
                    defaultIdentity: currentWorkspace?.visualIdentity?.defaultIdentity,
                    defaultIdentityColor:
                      currentWorkspace?.visualIdentity?.secondaryBackgroundColor || '#C0D3FF',
                    isActive: isActive,
                  }).backgroundColor
                }
              />
            </div>
            <div className="absolute bottom-0 -right-6 size-6 ">
              <CurvedCorner
                corner="bottom-left"
                shadowColor={
                  getConditionalBackgroundStyle({
                    theme: currentWorkspace?.visualIdentity?.theme || 'LIGHT',
                    defaultIdentity: currentWorkspace?.visualIdentity?.defaultIdentity,
                    defaultIdentityColor:
                      currentWorkspace?.visualIdentity?.secondaryBackgroundColor || '#C0D3FF',
                    isActive: isActive,
                  }).backgroundColor
                }
              />
            </div>
          </div>
        );
      case 'last':
        return (
          <div
            className="absolute -bottom-4 left-0 w-full h-4 z-10"
            style={getConditionalBackgroundStyle({
              theme: currentWorkspace?.visualIdentity?.theme || 'LIGHT',
              defaultIdentity: currentWorkspace?.visualIdentity?.defaultIdentity,
              defaultIdentityColor:
                currentWorkspace?.visualIdentity?.secondaryBackgroundColor || '#C0D3FF',
              isActive: isActive,
            })}
          >
            <div className="absolute bottom-0 -left-6 size-6 ">
              <CurvedCorner
                corner="bottom-right"
                shadowColor={
                  getConditionalBackgroundStyle({
                    theme: currentWorkspace?.visualIdentity?.theme || 'LIGHT',
                    defaultIdentity: currentWorkspace?.visualIdentity?.defaultIdentity,
                    defaultIdentityColor:
                      currentWorkspace?.visualIdentity?.secondaryBackgroundColor || '#C0D3FF',
                    isActive: isActive,
                  }).backgroundColor
                }
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="relative w-full h-full">
      {children}
      {getConnectorClasses()}
    </div>
  );
}
